import withTranslation from 'lib/shared/i18n/withTranslation';

import BaseField from '../BaseField/BaseField';

class TextField extends BaseField {}

export default withTranslation()(TextField);
